import { render, staticRenderFns } from "./MatrizCero.vue?vue&type=template&id=e53d3058&scoped=true"
import script from "./MatrizCero.vue?vue&type=script&lang=js"
export * from "./MatrizCero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.44_cache-loader@4.1.0_webpack@4.47.0_supports-_3d59c31a03e2fcdc80db74fb8fd2eaf6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53d3058",
  null
  
)

export default component.exports